import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Row } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import { Input, CheckBox } from 'components';
import { useStorage64 } from 'pages/Header/Content/hooks/useStorageBase64';
import { PROFILE_DATA } from 'constants/storage64';
import styles from './stylesHonoredGuestsName.module.scss'

const HonoredGuestsName = ({
  isFirst,
  id,
  name,
  label,
  hideResponsable,
  noResponsable,
  setChangeForm,
  handleKeyPress
}) => {
  const [profileData] = useStorage64(PROFILE_DATA);
  const { nombre = '', apellidoP = '' } = profileData || {};

  const { setFieldValue } = useFormikContext()

  const { firstName, lastName } = useMemo(() => ({
    firstName: `${id}_firstname`,
    lastName: `${id}_lastname`,
  }), [id]);

  useEffect(() => {
    if (isFirst) {
      setFieldValue(firstName, nombre);
      setFieldValue(lastName, apellidoP);
    }
  }, [isFirst, nombre, apellidoP, firstName, lastName]);
  const setKeyPressForm = ()=>{
    console.log("*****AQUI ESTOY*******")
    setChangeForm()
    
  }
  return (
      <>
        <Form.Group className={`row justify-content-center ${styles['inputs-container']}`}>
          <Form.Label className="col-md-12 col-lg-6" style={{ textAlign: 'left',marginBottom: '2rem' }}>
            {name || label}:
          </Form.Label>
          <Col md="12" lg="7">
            <Input
                onKeyPress={handleKeyPress}
                inputMode="name"
                name={firstName}
                placeholder="Nombre (s)"
                className="inputBorder"
            />
          </Col>
          <Col md="12" lg="7">
            <Input
                onKeyPress={handleKeyPress}
                inputMode="name"
                name={`${id}_lastname`}
                placeholder="Apellidos"
                className="inputBorder"
            />
          </Col>
        </Form.Group>

        {!noResponsable && (
            <Row className="justify-content-center">
              <Col md="12" lg="7">
                <CheckBox
                    onKeyPress={setKeyPressForm}
                    name="responsable"
                    label="Responsable del evento"
                    type="radio"
                    groupClassName={`my-0 ${hideResponsable ? 'd-none' : ''}`}
                    value={id}
                />
              </Col>
            </Row>
        )}
      </>

  );
}

HonoredGuestsName.propTypes = {
  isFirst: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  label: PropTypes.string,
  hideResponsable: PropTypes.bool,
  noResponsable: PropTypes.bool,
};

export default HonoredGuestsName;
